<script setup lang="ts">
const props = withDefaults(defineProps<{
  title: string
  icon?: string
}>(), {
  icon: 'mdi-rocket',
})
</script>

<template>
  <div class="rounded  border border-neutral-100 bg-white/80 p-4 shadow-md shadow-neutral-50 lg:grid dark:border-neutral-700 dark:bg-neutral-900 dark:shadow-black">
    <header class="mb-4 flex items-center">
      <h2 class="flex items-center gap-2 font-heading text-xl font-bold text-neutral-600 dark:text-neutral-400">
        <UIcon :name="props.icon" class="size-6 text-secondary-700 dark:text-neutral-600" />
        {{ props.title }}
      </h2>
    </header>
    <div class="grow">
      <slot />
    </div>
  </div>
</template>
